import Flickity from 'flickity';
require('flickity-fade');

import { preloadImagesIn } from "../utils";
class timeline {
  constructor(context) {
    context.querySelectorAll('[data-timeline]').forEach(element => {
      const dates = element.querySelector('.timeline__timeline');
      const images = element.querySelector('.timeline__images');
      const content = element.querySelector('.timeline__content');

      images.querySelectorAll('a').forEach(item => {
        item.addEventListener('click', e => {
          e.preventDefault();
          return false;
        })
      });

      let flktyDates, flktyImages, flktyContent;

      flktyDates = new Flickity(dates, {
        pageDots: false,
        contain: false,
        prevNextButtons: false,
        cellAlign: 'center'
      });

      flktyContent = new Flickity(content, {
        pageDots: false,
        contain: true,
        prevNextButtons: false,
        cellAlign: 'left',
        fade: true,
        adaptiveHeight: true
      });

      const moveTo = ((id, except) => {
        // Move dates
        if (except != 'dates') {
          flktyDates.slides.every((item, index) => {
            const slide = item.cells[0].element;
            if (slide.dataset.timelineKey == id) {
              flktyDates.select(index);
              return false;
            }
            return true;
          });
        }
        
        // Move images
        if (except != 'images') {
          flktyImages.slides.every((item, index) => {
            const slide = item.cells[0].element;
            if (slide.dataset.timelineKey == id) {
              flktyImages.select(index);
              return false;
            }
            return true;
          });
        }
        
        flktyContent.slides.every((item, index) => {
          const slide = item.cells[0].element;
          if (slide.dataset.timelineKey == id) {
            flktyContent.select(index);
            return false;
          }
          return true;
        });

      });

      preloadImagesIn(images).then(_ => {
        flktyImages = new Flickity(images, {
          pageDots: false,
          contain: false,
          prevNextButtons: false,
          cellAlign: 'center',
          adaptiveHeight: true
        });

        flktyImages.on('change', index => {
          const slide = flktyImages.slides[index].cells[0].element;
          const id = slide.dataset.timelineKey;
          moveTo(id, 'images');
        });

        flktyDates.on('change', index => {
          const slide = flktyDates.slides[index].cells[0].element;
          const id = slide.dataset.timelineKey;
          moveTo(id, 'dates');
        });

        flktyDates.on('staticClick', function (event, pointer, cellElement, cellIndex) {
          flktyDates.select(cellIndex);
        });

        flktyImages.on('staticClick', function (event, pointer, cellElement, cellIndex) {
          flktyImages.select(cellIndex);
        });
      });
    });
  }
};

export default timeline;